var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./broker/broker.module": [
		"./src/app/broker/broker.module.ts",
		"common",
		"broker.module"
	],
	"./documents/documents.module": [
		"./src/app/documents/documents.module.ts",
		"common",
		"documents.module"
	],
	"./interfaces/interfaces.module": [
		"./src/app/interfaces/interfaces.module.ts",
		"common",
		"interfaces.module"
	],
	"./kardex/kardex.module": [
		"./src/app/kardex/kardex.module.ts",
		"kardex.module"
	],
	"./logSAP/log.module": [
		"./src/app/logSAP/log.module.ts",
		"common",
		"log.module"
	],
	"./notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"common",
		"notifications.module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile.module"
	],
	"./repositories/repositories.module": [
		"./src/app/repositories/repositories.module.ts",
		"repositories.module"
	],
	"./smtp/smtp.module": [
		"./src/app/smtp/smtp.module.ts",
		"smtp.module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"common",
		"starter.module"
	],
	"./supplier/supplier.module": [
		"./src/app/supplier/supplier.module.ts",
		"supplier.module",
		"common"
	],
	"./three-way-match/three-way-match.module": [
		"./src/app/three-way-match/three-way-match.module.ts",
		"common",
		"three-way-match.module"
	],
	"./uploads/uploads.module": [
		"./src/app/uploads/uploads.module.ts",
		"common",
		"uploads.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main